
import { useEffect, useState } from "react";
import { Col, Container, Nav, Navbar, Row } from 'react-bootstrap';

import { Link } from "react-router-dom";
import AccessibilityTools from '../AccessibilityToolbar.js';
import TranslatorPopup from '../TranslatorPopup.js';
import { FiSearch } from 'react-icons/fi';
import NavDropdown from 'react-bootstrap/NavDropdown';
import ImageComponent from "../CommonUtils/ImageViewCommonCode.js";
import { IoAppsSharp } from "react-icons/io5";
import SideModal from "../Sidemodal.js";
import CitizenServicesModal from "../citizenServices.js";
import OnlinePaymentModal from "../payment-popup.js";
import '../styles.css'
import { Navigate, NavLink, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

// aaaaaaaaaaaaa
export default function TopStripHeader() {
    const [showCitizenModal, setShowCitizenModal] = useState(false);
    const [showSideModal, setShowSideModal] = useState(false);
    const [showPaymentModal, setShowPaymentModal] = useState(false);

    const handleShowSideModal = () => setShowSideModal(true);
    const handleShowCitizenModal = () => setShowCitizenModal(true);
    const handleCloseCitizenModal = () => setShowCitizenModal(false);
    const handleCloseSideModal = () => setShowSideModal(false);

    const handleShowPaymentModal = () => setShowPaymentModal(true);
    const handleClosePaymentModal = () => setShowPaymentModal(false);

    const navigate = useNavigate();


    /*  const [showCitizenSvamithvaModal, setShowCitizenSvamithvaModal] = useState(false);
     const handleShowCitizenSvamithvaModal = () => setShowCitizenSvamithvaModal(true);
     const handleCloseCitizenSvamithvaModal = () => setShowCitizenSvamithvaModal(false); */

    // useEffect(() => {
    //     const script = document.createElement("script");
    //     script.src = "https://cse.google.com/cse.js?cx=YOUR_SEARCH_ENGINE_ID";
    //     script.async = true;
    //     document.body.appendChild(script);
    // }, []);

    // useEffect(() => {
    //     const script = document.createElement("script");

    //     // NOSONAR - Google dynamic script, integrity not supported
    //     script.src = "https://cse.google.com/cse.js?cx=YOUR_SEARCH_ENGINE_ID";

    //     script.async = true;
    //     script.crossOrigin = "anonymous";

    //     document.body.appendChild(script);

    //     return () => {
    //         document.body.removeChild(script);
    //     };
    // }, []);
    useEffect(() => {
        const handleScroll = () => {
            const navbar = document.querySelector(".panch-nav");
            if (window.scrollY > 10) {
                navbar.classList.add("scrolled");
            } else {
                navbar.classList.remove("scrolled");
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);
const dispatch =useDispatch()
    return (
        <>
            <div className='topstrip'>
                <Row className="w-100">
                    <Col xs={12} sm={12} lg={4} md={4} xl={4} xxl={4}>
                        <div className="search-container">
                            <input
                                type="text"
                                placeholder="Search Here"
                                className="search-input"
                            />
                            <FiSearch className="search-icon" />
                        </div>
                    </Col>
                    <Col xs={12} sm={12} lg={8} md={8} xl={8} xxl={8}>
                        <div className='top-right'>
                            {/* <div className='skip-content'>
                                <a href='#skip' className='mb-0' title='Skip to main Content'>Skip to Main Content</a>
                            </div>

                            <div className="divider"></div> */}

                            <AccessibilityTools />

                            <div className="divider"></div>

                            <TranslatorPopup />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className='main-content' id="accessibility-wrapper">
                <Navbar expand="lg" fixed="top" className='panch-nav'>
                    <Container fluid className='px-0'>
                        <Navbar.Brand href="#home" className='d-flex align-items-center'>
                            {/* <a className="navbar-brand d-flex align-items-center ms-4" href="#"> */}
                            {/* <img src="images/logo.svg" alt="Logo" className='logo' /> */}

                            <ImageComponent imagepath={"Assets/1733296766878_logo.png"} typePhoto={"logo"} />
                            <div className="brand-text ms-2">
                                {/* <img src="images/logo-text.svg" alt="Logo Text" className='logo-text' /> */}

                                <ImageComponent imagepath={"Assets/1733296751655_logo-text.png"} typePhoto={"logotext"} />
                            </div></Navbar.Brand>
                        <Navbar.Toggle
                            aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse
                            id="basic-navbar-nav">
                            <Nav
                                className="ms-auto main-navbar">
                                {/*  <Nav.Link href="/" className='mx-0 mx-xl-2 active'
                                >Home</Nav.Link> */}

                                <Nav.Link as={NavLink}
                                    to="/"
                                    end
                                    className={({ isActive }) =>
                                        "mx-0 mx-xl-2 " + (isActive ? "active-link" : "")
                                    }
                                >Home</Nav.Link>
                                 <Nav.Link href="/SwarnaPanchayatServices" onClick={(e)=>{ dispatch({ type: "CITIZENPAYMENTHOME", payload:'payment' });}}
                      className='mx-0 mx-xl-2' >Online Payments</Nav.Link>

                                {/*  <NavDropdown title="Dashboard"
                                    id="basic-nav-dropdown" className='mx-0 mx-xl-2 text-center m-auto'>
                                    <NavDropdown.Item as={Link}
                                        to="/digitalization-dashboard" target="_blank">Digitalization</NavDropdown.Item>
                                    <NavDropdown.Item as={Link}
                                        to="/dcb-dashboard" target="_blank">DCB</NavDropdown.Item>  </NavDropdown> */}

                                {/* <NavDropdown.Item as={Link} to="/revenue-dashboard">Revenue</NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/panchayatraj-dashboard">Panchayat Profile</NavDropdown.Item> */}


                                <NavDropdown title="Dashboards"
                      id="basic-nav-dropdown" className='mx-0 mx-xl-2 text-center m-auto'>
                      <NavDropdown.Item as={Link}
                      
                        to="/dashboards/single">Citizen</NavDropdown.Item>
                     <NavDropdown.Item
                         as={Link}
                         to="/loginpage/dashboard"
                       >
                        
                         Employee
                       </NavDropdown.Item>
                    </NavDropdown>


                                {/* <Nav.Link onClick={handleShowModal} className='mx-0 mx-xl-2'>Citizen Services</Nav.Link> */}

                                <Nav.Link href="/SvamitvaPropertyDetails"
                                    className='mx-2'>
                                    SVAMITVA</Nav.Link>

                                  <Nav.Link href="/SwarnaPanchayatServices" onClick={(e)=>{ dispatch({ type: "CITIZENPAYMENTHOME", payload:'citizen' });}}
                                                     className='mx-0 mx-xl-2' >Citizen Services</Nav.Link>
                                {/* <Nav.Link href="/OutsidePanchayatProfileView"
                                    className='mx-0 mx-xl-2' >My Panchayat Profile</Nav.Link> */}

                                <Nav.Link as={NavLink} to="/OutsidePanchayatProfileView" end
                                    className={({ isActive }) =>
                                        "mx-0 mx-xl-2 " + (isActive ? "active-link" : "")
                                    }
                                >My Panchayat Profile</Nav.Link>

                                {/* <Nav.Link href="/outsearchgos"
                      className='mx-0 mx-xl-2' >GO's and Circulars</Nav.Link> */}
                                {/* <Nav.Link href="/outnotification"
                      className='mx-0 mx-xl-2' >Careers</Nav.Link> */}
                                {/* <Nav.Link href="/GalleryPage"
                      className='mx-0 mx-xl-2' >Gallery</Nav.Link> */}
                                {/* <Nav.Link href="/Contactus"
                                    className='mx-0 mx-xl-2'>Contact Us</Nav.Link> */}
                                <NavDropdown title="Login"
                                    id="basic-nav-dropdown" className='mx-0 mx-xl-2 text-center m-auto'>
                                    <NavDropdown.Item
                                        as={Link} to="/loginpage/main">Employee Login
                                    </NavDropdown.Item>
                                    <NavDropdown.Item
                                        as={Link} to="/supportloginpage">Support Login
                                    </NavDropdown.Item>
                                </NavDropdown>
                                <Nav.Link
                                    className='mx-0 mx-xl-2' onClick={handleShowSideModal}><IoAppsSharp size={25} /></Nav.Link>
                            </Nav></Navbar.Collapse></Container></Navbar>
                <SideModal show={showSideModal} handleClose={handleCloseSideModal} />
                <CitizenServicesModal show={showCitizenModal}
                    handleClose={handleCloseCitizenModal} />
                {/* <SvamithvaCitizenServices show={showCitizenSvamithvaModal}
              handleClose={handleCloseCitizenSvamithvaModal} /> */}

                <OnlinePaymentModal show={showPaymentModal}
                    handleClose={handleClosePaymentModal} />
            </div>
        </>
    );
}